import { ASSETS_URL, ReviewProduct, ReviewType, VideoReview } from '../../types';
import subs from '@/static/assets/reviews/Jessica_Renters/subs.vtt';
import poster from '@/static/assets/reviews/Jessica_Renters/video.jpg';

export const Jessica: VideoReview = {
  type: ReviewType.Video,
  product: [ReviewProduct.Renters, ReviewProduct.All],
  reviewerName: 'Jessica',
  videoUrl: `${ASSETS_URL}/renters/Jessica_Renters.webm`,
  posterUrl: poster,
  captionsUrl: subs,
};
